import React, { useMemo } from 'react';
import { TabsProvider } from 'src/ui/common/molecules/tabs/tabs.provider';
import { ITabsProps } from 'src/ui/common/molecules/tabs/tabs.types';
import { TabContent } from 'src/ui/white-labels/ocean/molecules/tabs/tab-content';
import { ITabs } from 'src/ui/white-labels/ocean/molecules/tabs/tab.types';
import { TabItem, TabItems } from './tab-items';

export const Tabs: ITabs<ITabsProps> = ({ selectedTabId, handleSelectTab, children }) => {
    const contextValue = useMemo(
        () => ({
            selectedTabId,
            handleSelectTab,
        }),
        [selectedTabId, handleSelectTab]
    );

    return <TabsProvider.Provider value={contextValue}>{children}</TabsProvider.Provider>;
};

Tabs.TabItems = TabItems;
Tabs.TabItem = TabItem;
Tabs.Content = TabContent;
